import React from "react";

// Descriptions are based on the public repository READMEs, without claiming a license.
const tools = [
  {
    category: "01 / Sequencing",
    icon: "⌁",
    title: "WORF Pipeline",
    subtitle: "从测序数据到分析图表",
    description: "整合质控、比对、计数与差异分析，串联 WORF 数据分析全流程，支持分步执行与续跑。",
    tags: ["FASTQ", "QC → 比对", "计数 → 差异分析", "可视化"],
    url: "https://github.com/alex90thu/Worf_pipeline",
  },
  {
    category: "02 / Analysis",
    icon: "∿",
    title: "worfscore2",
    subtitle: "WORF-SNAP 差异分析与绘图",
    description:
      "处理 diff 与 read_count 数据，完成预处理、排序、注释和筛选，输出散点图等可视化结果。",
    tags: ["差异分析", "数据筛选", "可视化"],
    url: "https://github.com/alex90thu/worfscore2",
  },
  {
    category: "03 / Gene Editing",
    icon: "⋈",
    title: "CRISPResso Async UI",
    subtitle: "基因编辑分析的轻量界面",
    description:
      "通过 Streamlit 异步提交 CRISPResso2 分析任务，在静态结果门户查看任务状态、日志与分析报告。",
    tags: ["CRISPResso2", "异步任务", "结果浏览"],
    url: "https://github.com/alex90thu/crispresso_tool",
  },
];

export default function ResearchTools() {
  return (
    <section id="tools" className="page-section tools-section" aria-labelledby="tools-title">
      <div className="section-heading">
        <h2 id="tools-title">
          科研工具 <span lang="en">/ Code &amp; Tools</span>
        </h2>
        <a
          className="text-link"
          href="https://github.com/alex90thu"
          target="_blank"
          rel="noreferrer"
        >
          更多 GitHub 项目 <span aria-hidden="true">↗</span>
        </a>
      </div>
      <p className="tools-intro">将研究中的分析步骤，整理为可使用、可复现的工具。</p>
      <div className="tools-grid">
        {tools.map((tool) => (
          <article className="tool-card" key={tool.url}>
            <div className="tool-top">
              <span lang="en">{tool.category}</span>
              <span className="tool-icon" aria-hidden="true">
                {tool.icon}
              </span>
            </div>
            <h3 lang="en">{tool.title}</h3>
            <p className="tool-name">{tool.subtitle}</p>
            <p className="tool-description">{tool.description}</p>
            <ul className="tool-flow" aria-label="工具功能">
              {tool.tags.map((tag) => (
                <li key={tag}>{tag}</li>
              ))}
            </ul>
            <a
              className="tool-link"
              href={tool.url}
              target="_blank"
              rel="noreferrer"
              aria-label={`查看 ${tool.title} 的代码与使用说明`}
            >
              <span>查看代码与使用说明</span>
              <span aria-hidden="true">↗</span>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
